import React from "react";
import { Box, Typography } from "@mui/material";
import { useReducedMotion } from "framer-motion";
import CountUp from "react-countup";
import { CalendarCheck, CalendarDays, FileText, TrendingUp, UserCheck } from "lucide-react";
import UserAvatar from "../common/UserAvatar";

const ICONS = {
  "user-check": UserCheck,
  "file-text": FileText,
  "trending-up": TrendingUp,
  "calendar-days": CalendarDays,
  "calendar-check": CalendarCheck,
};
const COLORS = {
  candidates_hired:        "hsl(142, 71%, 45%)",
  applications_made:       "hsl(217, 91%, 55%)",
  sign_rate:               "hsl(168, 58%, 33%)",
  peak_day_candidates:     "hsl(142, 71%, 45%)",
  peak_week_candidates:    "hsl(142, 71%, 45%)",
  peak_month_candidates:   "hsl(142, 71%, 45%)",
  peak_day_applications:   "hsl(217, 91%, 55%)",
  peak_week_applications:  "hsl(217, 91%, 55%)",
  peak_month_applications: "hsl(217, 91%, 55%)",
};

const ChampionCard = ({ champion }) => {
  const reduce = useReducedMotion();
  const Icon = ICONS[champion.icon] || UserCheck;
  const color = COLORS[champion.key] || "hsl(150, 38%, 17%)";
  const isPercent = champion.suffix === "%";

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        border: "1px solid hsl(140, 8%, 88%)",
        borderRadius: "8px",
        p: "20px",
      }}
    >
      <Box sx={{ width: 42, height: 42, borderRadius: "11px", backgroundColor: "hsl(140, 8%, 97%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon size={20} color={color} strokeWidth={2} />
      </Box>
      <Typography sx={{ fontSize: 12, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "hsl(150, 10%, 46%)", mt: "16px" }}>
        {champion.label}
      </Typography>
      <Typography sx={{ fontSize: 34, fontFamily: "Segoe UI Bold, sans-serif, system-ui", color: "hsl(150, 30%, 12%)", lineHeight: 1, letterSpacing: "-0.8px", mt: "6px" }}>
        <CountUp end={Number(champion.value) || 0} duration={reduce ? 0 : 1.1} separator="," decimals={isPercent ? 1 : 0} suffix={champion.suffix || ""} />
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mt: "16px", pt: "14px", borderTop: "1px solid hsl(140, 8%, 91%)" }}>
        {champion.holder ? (
          <>
            <UserAvatar user={champion.holder} size={26} />
            <Typography sx={{ fontSize: 13, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "hsl(150, 18%, 28%)" }} noWrap>
              {champion.holder.full_name}
            </Typography>
          </>
        ) : (
          <Typography sx={{ fontSize: 13, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150, 10%, 46%)" }}>
            No data yet
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ChampionCard;
